"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _i18next = _interopRequireDefault(require("i18next"));
var _reactI18next = require("react-i18next");
var _i18nextXhrBackend = _interopRequireDefault(require("i18next-xhr-backend"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
_i18next["default"].use(_i18nextXhrBackend["default"]).use(_reactI18next.initReactI18next) // passes i18n down to react-i18next
.init({
  lng: sessionStorage.getItem('Posco.Multilang.Code') || 'ko',
  fallbackLng: sessionStorage.getItem('Posco.Multilang.Code') || 'ko',
  ns: ['common', 'service'],
  defaultNS: "service",
  debug: true,
  keySeparator: false,
  // we do not use keys in form messages.welcome
  interpolation: {
    escapeValue: false // react already safes from xss
  },
  backend: {
    loadPath: function loadPath() {
      var node_env = process.env.NODE_ENV;
      console.log('NODE_ENV is !!! ', node_env);
      return (node_env === 'production' ? process.env.PUBLIC_URL : '') + '/locales/{{lng}}/{{ns}}.json';
    }
  }
});
console.log('hello i18n');
var _default = _i18next["default"];
exports["default"] = _default;